export default "__VITE_ASSET__Cs3za3L9__"